import QUERY from 'lodash'

export default {
  methods: {

    getApiBaseUrl () {
      return (process.env.VUE_APP_API_URL || '').replace(/\/$/, '')
    },

    getApiBaseRootUrl () {
      return this.getApiBaseUrl().replace(/\/api\/?$/, '')
    },

    resolveStoragePath (path = '') {
      if (!path) return ''

      if (/^https?:\/\//i.test(path)) {
        return path
      }

      const normalized = String(path).replace(/^\/+/, '')

      if (normalized.startsWith('profile-photos/')) {
        const filename = normalized.split('/').pop()
        return filename
          ? `${this.getApiBaseUrl()}/shared/uploads/profile-photos/view/${encodeURIComponent(filename)}`
          : ''
      }

      if (normalized.startsWith('lf-items/images/')) {
        const filename = normalized.split('/').pop()
        return filename
          ? `${this.getApiBaseUrl()}/shared/uploads/lf-items/images/${encodeURIComponent(filename)}`
          : ''
      }

      if (normalized.startsWith('lf-claims/images/')) {
        const filename = normalized.split('/').pop()
        return filename
          ? `${this.getApiBaseUrl()}/shared/uploads/lf-claims/images/${encodeURIComponent(filename)}`
          : ''
      }

      if (normalized.startsWith('announcements/images/')) {
        const filename = normalized.split('/').pop()
        return filename
          ? `${this.getApiBaseUrl()}/shared/uploads/announcements/images/${encodeURIComponent(filename)}`
          : ''
      }

      if (normalized.startsWith('events/images/')) {
        const filename = normalized.split('/').pop()
        return filename
          ? `${this.getApiBaseUrl()}/shared/uploads/events/images/${encodeURIComponent(filename)}`
          : ''
      }

      return `${this.getApiBaseRootUrl()}/${normalized}`
    },

    transformToImageUrl (path = '') {
      return this.resolveStoragePath(path)
    },

    sampleImage () {
      return this.transformToImageUrl(process.env.VUE_APP_SAMPLE_IMAGE)
    },

    getCompany (rootDirectory = 'branding') {
      return `${rootDirectory}/${process.env.VUE_APP_COMPANY_LOGO}`
    },

    getProfile (rootDirectory = 'branding') {
      return `${rootDirectory}/${process.env.VUE_APP_PROFILE_LOGO}`
    },

    getRepresentativeProfile (photoUrl) {
      return this.resolveStoragePath(photoUrl)
    },

    getCustomerProfile (photos = []) {
      const customerPhoto = QUERY.first(photos)
      if (customerPhoto) {
        return `${process.env.VUE_APP_API_BASE_URL}/customer-photos-attachments/${customerPhoto.attachment_path}/${customerPhoto.file_name}`
      }

      return `${window.location.origin}/img/invalid-image.png`
    },

    getTradingTermAttachmentPath (tradingTerm) {
      if (tradingTerm) {
        return `${process.env.VUE_APP_API_BASE_URL}/trading-terms-attachments/${tradingTerm.attachment_path}/${tradingTerm.file_name}`
      }

      return `${window.location.origin}/img/invalid-image.png`
    }

  }
}
